export default "__VITE_ASSET__Du1ptiRy__"